import { Link } from 'react-router-dom';
import { ChevronDown, Command } from 'lucide-react';
import { Monogram } from './Monogram';
import { BellDropdown } from './BellDropdown';
import { AvatarMenu } from './AvatarMenu';

interface Props {
  projectId: string;
  projectCode: string;
  snapshotLabel: string;
  onOpenCommand: () => void;
}

/** Топ-бар для проектного дашборда: brand · Проект · Редакция · ⌘K · Bell · Avatar+меню.
    Меню пользователя — общий AvatarMenu (с плашкой тарифа проекта). */
export function DashboardTopBar({ projectId, projectCode, snapshotLabel, onOpenCommand }: Props) {
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-border" style={{ height: 48 }}>
      <div className="mx-auto h-full flex items-center" style={{ maxWidth: 1280, paddingLeft: 24, paddingRight: 24, gap: 16 }}>
        <Link to="/projects" className="flex items-center" style={{ gap: 10 }}>
          <Monogram size={28} fontSize={16} />
          <span className="font-heading text-ink" style={{ fontSize: 15, fontWeight: 600, letterSpacing: '-0.01em' }}>Коллегиум</span>
        </Link>

        <span className="text-muted select-none">·</span>

        <Link
          to="/projects"
          className="inline-flex items-center text-ink hover:bg-surface rounded-btn"
          style={{ padding: '4px 10px', gap: 6, fontWeight: 500, fontSize: 14 }}
          aria-label="Переключить проект"
        >
          <span className="text-muted">Проект:</span>
          <span>{projectCode}</span>
          <ChevronDown size={16} className="text-muted" />
        </Link>

        <Link
          to={`/project/${projectId}?tab=docs`}
          className="inline-flex items-center text-muted hover:text-ink hover:bg-surface rounded-btn"
          style={{ padding: '4px 10px', gap: 6, fontWeight: 500, fontSize: 14, cursor: 'pointer' }}
          title="Список редакций — на вкладке Документы"
        >
          <span>Редакция:</span>
          <span className="text-ink">{snapshotLabel}</span>
          <ChevronDown size={16} />
        </Link>

        <div className="flex-1" />

        <button
          type="button"
          onClick={onOpenCommand}
          className="inline-flex items-center text-muted hover:text-ink hover:border-ink/20"
          style={{ border: '1px solid #E5E7EB', borderRadius: 999, padding: '4px 12px', gap: 6, fontSize: 12, background: 'white', cursor: 'pointer' }}
          aria-label="Открыть поиск"
          title="⌘K"
        >
          <Command size={14} />
          <span>K</span>
          <span className="ml-1">Поиск</span>
        </button>

        <BellDropdown />
        <AvatarMenu projectId={projectId} />
      </div>
    </header>
  );
}
